import React from 'react';
import PropTypes from 'prop-types';
import { Collapsable } from '@fiverr/fit/src';
import I18n from '@fiverr-private/fiverr_context/src/I18n';
import SafePureComponent from '../shared/SafePureComponent';
import { validateFaq } from '../../utils/mainComponentsValidator';
import QuestionOrAnswer from './QuestionOrAnswer';

import './style.scss';

const Faq = ({faq}) => {
    // todo: maintain error
    if (!validateFaq({faq, error: false})) {
        return null;
    }

    const {
        questionsAndAnswers
    } = faq;

    return (
        <div className="faq-collapsable">
            <Collapsable group="gig-faq-header">
                {() => (
                    <h2 className="section-title"><I18n k={'gig_page_perseus.faq.title'}/></h2>
                )}
                {() => (
                    questionsAndAnswers.map(({ question, answer }, index) => question && answer && (
                        <Collapsable group="gig-faq-group" key={index}>
                            { () => <QuestionOrAnswer value={question} type={'question'}/> }
                            { () => <QuestionOrAnswer value={answer} type={'answer'}/> }
                        </Collapsable>
                    ))
                )}
            </Collapsable>
        </div>
    );
};

Faq.propTypes = {
    faq: PropTypes.shape({
        questionsAndAnswers: PropTypes.arrayOf(
            PropTypes.shape({
                question: PropTypes.string,
                answer: PropTypes.string
            })
        )
    })
};

export { Faq };
export default SafePureComponent(Faq);
